module.exports = new __parcel__URL__("lune-nuage-2.bbb32705.svg").toString();